import { ConnectError } from '@connectrpc/connect';

export function isApiError(error: unknown): error is ConnectError {
  if (error instanceof Error) {
    return error.name === 'ConnectError';
  }
  return false;
}
